import { Route, Routes } from "react-router-dom";
import { IndexPage } from "./pages/index";

function DriverRoadTestRoutes() {
    return (
        <Routes>
            <Route index element={<IndexPage />} />
        </Routes>
    );
}

export { DriverRoadTestRoutes };
